import * as React from 'react';
import DeleteConfirmation from "../../Components/DeleteConfirmation";

function DeleteProject(props) {
    return (
        <DeleteConfirmation
            id={props.id}
            title={'Usuń projekt'}
            subtitle={'Czy na pewno chcesz usunąć dane tego projektu?'}
            url={'/api/project'}
            onSuccess={props.onSuccess}
        />
    )
}

export default DeleteProject;